import React from "react";
// material ui
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Button,
  IconButton,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { NotListedLocation } from "@mui/icons-material";

// ------------------------------------------------------------------------



//   -------------------------------------------------------------------------------

const ConfirmDialog = (props) => {
  const { confirmDialog, isViewClientAssessor} = props;

  const useStyles = makeStyles((theme) => ({
  dialog: {
    padding: theme.spacing(2),
    position: "absolute",
    top: theme.spacing(5),
  },
  dialogTitle: {
    textAlign: "center",
  },
  dialogContent: {
    textAlign: "center",
  },
  dialogAction: {
    justifyContent: "center",
  },
  titleIcon: {
    backgroundColor: theme.palette.grey.light,
    color: theme.palette.grey.main,
    "&:hover": {
      backgroundColor: theme.palette.grey.light,
      cursor: "default",
    },
    "& .MuiSvgIcon-root": {
      fontSize:  isViewClientAssessor ? "4rem" : "8rem",
    },
  },
}));

  const classes = useStyles();
  return (
    <Dialog open={confirmDialog.isOpen} classes={{ paper: classes.dialog }}>
      <DialogTitle className={classes.dialogTitle}>
        <IconButton disableRipple className={classes.titleIcon}>
          <NotListedLocation />
        </IconButton>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <Typography variant="h6">{confirmDialog.title}</Typography>
        <Typography variant="subtitle2">{confirmDialog.subTitle}</Typography>
      </DialogContent>
      <div style={{display:"flex" , justifyContent:"center"}}>
       {!isViewClientAssessor && <DialogActions>
        <Button
          inputProps={{ tabIndex: "1" }}
          variant="contained"
          color="primary"
          onClick={() => props.setConfirmDialog({ isOpen: false })}
        >
          No
        </Button>
        <Button
          inputProps={{ tabIndex: "2" }}
          variant="contained"
          color="red"
          onClick={confirmDialog.onConfirm}
        >
          Yes
        </Button>
      </DialogActions>}

      {isViewClientAssessor && <DialogActions>
        <Button
          inputProps={{ tabIndex: "1" }}
          variant="contained"
        
           color="red"
          onClick={() => props.setConfirmDialog({ isOpen: false })}
        >
          Cancel
        </Button>
        <Button
         sx={{textTransform:"none"}}
          inputProps={{ tabIndex: "2", }}
          variant="contained"
           color="primary"
          onClick={confirmDialog.onConfirm}
        >
          Send Reminder
        </Button>
      </DialogActions>}
      </div>
    </Dialog>
  );
};

export default ConfirmDialog;
